import { fold } from 'fp-ts/lib/Either';
import { pipe } from 'fp-ts/lib/pipeable';
import uniq from 'lodash/uniq';
var isValidContext = function (context) {
    return !!context.key && isNaN(parseInt(context.key));
};
var getErrorMessageFromContext = function (context) {
    var keyPath = context.filter(isValidContext);
    if (!keyPath.length) {
        return '';
    }
    var desiredVariableType = keyPath[keyPath.length - 1].type.name;
    return keyPath.map(function (_a) {
        var key = _a.key;
        return key;
    }).join('.') + " | should be type: ".concat(desiredVariableType);
};
var getInvalidPathsForErrors = function (errors) {
    var allPaths = errors.map(function (error) { return getErrorMessageFromContext(error.context); });
    var allNonEmptyPaths = allPaths.filter(function (path) { return !!path; });
    return uniq(allNonEmptyPaths);
};
/**
 * Function parses out invalid object paths for an invalid interface type. For example, if you have the codec:
 * const Person = t.type({
 *   name: t.string,
 *   age: t.number,
 *   livesIn: {
 *     city: t.string,
 *     zipCode: t.number
 *   }
 * })
 *
 * and you want to validate the object
 *
 * const max = {
 *  name: "Max Lloyd",
 *  age: "Don't worry about it", // invalid type
 *  livesIn: {
 *    zipCode: 12345, // not providing required 'city' parameter
 *  }
 * }
 *
 * running Person.decode(max) returns a io-ts validator and
 *
 * const validatorForMax = Person.validate(max)
 * getInvalidInterfacePaths(validatorForMax) => ['age', 'livesIn.city']
 *
 * @param v io-ts Validator (returned if `decode` is called on any io-ts codec)
 */
export var getInvalidInterfacePaths = function (v) {
    return pipe(v, fold(getInvalidPathsForErrors, function () { return ['no errors']; }));
};
//# sourceMappingURL=interfaceValidator.js.map